var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Typography, Grid } from '@mui/material';
import styled from 'styled-components';
var LabelText = styled(Typography).attrs({
    variant: 'subtitle1',
    role: 'title',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ValueText = styled(Typography).attrs({
    variant: 'body2',
    role: 'body',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  word-break: break-all;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n"], ["\n  word-break: break-all;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n"])));
var LabeledGridItem = function (_a) {
    var label = _a.label, value = _a.value, labelGridProps = _a.labelGridProps, valueGridProps = _a.valueGridProps;
    var body = typeof value == 'number' ? "".concat(value) : value;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, __assign({ item: true, xs: 12, sm: 3 }, labelGridProps),
            React.createElement(LabelText, null,
                label,
                ":")),
        React.createElement(Grid, __assign({ item: true, xs: 12, sm: 9 }, valueGridProps),
            React.createElement(ValueText, null, body || ''))));
};
export default LabeledGridItem;
var templateObject_1, templateObject_2;
